<template>
  <v-app id="app">
    <v-content id="full_div">
      <v-alert
        color="error"
        dismissible
        :value="!storageAvailable"
      >
        La configuration de votre navigateur ne permet pas d'enregistrer
        les préférences. Certains atouts (reconnexion automatique) ne
        sont dès lors pas fonctionnels. Merci de votre compréhension.
      </v-alert>
      <elac-message />
      <elac-message-popup />
      <elac-login-popup />
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import ElacLoginPopup from '@/components/ElacLoginPopup.vue';
import ElacMessage from '@/components/ElacMessage.vue';
import ElacMessagePopup from '@/components/ElacMessagePopup.vue';
import Vue from 'vue';

export default {
  name: 'Elac',

  components: {
    ElacLoginPopup,
    ElacMessage,
    ElacMessagePopup,
  },

  data: () => ({}),

  computed: {
    storageAvailable() {
      return Vue.prototype.$storage.available();
    },
  },

  created() {
    const errInterceptor = (err) => {
      const res = (err.response && err.response.data) || {};
      const msg = (res.error && res.error.message) || (err && err.message);
      const status = err.response && err.response.status;

      if (status === 401 || status === 403) {
        if (this.$route.name !== 'home') {
          this.$store.commit('auth/show');
        } else {
          this.$store.commit('msg/show', {
            message: "Nom d'utilisateur ou mot de passe incorrect",
            type: 'error',
          });
        }
      } else {
        this.$store.commit('msg/show', { message: msg, type: 'error' });
      }

      throw err;
    };

    Vue.prototype.$api.interceptors.response.use(undefined, errInterceptor);
  },
};
</script>

<style>
body {
  margin: 0px;
  font-family: Helvetica, Verdana, sans-serif;
}

#full_div {
  position: absolute;
  overflow-x: auto;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 0;
}
</style>
